import { render } from "./CreatePassBlockingForm.vue?vue&type=template&id=cbe9929a"
import script from "./CreatePassBlockingForm.vue?vue&type=script&lang=js"
export * from "./CreatePassBlockingForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__